
import { mapState } from 'vuex'
import { requireGuest } from '~/middleware/auth'

export default {
  authRedirectHome: '/coupons/redeem',
  auth: 'guest',
  middleware: requireGuest({ redirectTo: '/coupons/redeem' }),

  head() {
    return {
      title: this.redeemCouponPageSettings.login_title,
    }
  },

  computed: {
    ...mapState('global', ['redeemCouponPageSettings']),
  },
}
